import { Typography } from "@mui/material";
import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { FIELD_PREFIX } from "../../../utils";

const DragItem = ({ token }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `${FIELD_PREFIX}${token}`,
    data: { type: "field", name: token }
  });

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        opacity: isDragging ? 0 : 1,
        cursor: "grab"
      }}
    >
      <Typography noWrap pl={1}>
        {token}
      </Typography>
    </div>
  );
};

export default DragItem;
